import React from 'react';

import BackFaceIcon from '../../../../assets/icons/question.png';

import './style.css';

export interface GameCardProps {
    image: string;
    flipped?: boolean;

    onClick?: VoidFunction;
}

export const GameCard: React.FC<GameCardProps> = ({ image, flipped, onClick }) => {
    const rootClass = flipped ? 'game-card__root flipped' : 'game-card__root';

    return (
        <div className={rootClass} onClick={onClick}>
            <div className="game-card__inner">
                <img className='game-card__image--front' src={image} />
                <img className='game-card__image--back' src={BackFaceIcon} />
            </div>
        </div>
    );
}; 
